export const TikTokIcon = ({ size = 17, className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M16.5 3c.32 2.1 1.5 3.55 3.5 3.86v2.45c-1.32.13-2.48-.3-3.62-1.02v5.94c0 3.53-2.62 5.87-5.83 5.77A5.6 5.6 0 0 1 5 14.4c0-3.43 3.02-6.03 6.62-5.28v2.66c-.44-.14-.9-.22-1.35-.2-1.6.05-2.74 1.35-2.55 2.94.16 1.35 1.4 2.35 2.77 2.28 1.5-.08 2.56-1.28 2.56-2.86V3h3.45Z" />
  </svg>
);
